import { createReducer, on } from "@ngrx/store";
import { addPermisos, addPermisosError, clearPermisos, deletePermiso, updatePermiso } from "../actions/permisos.actions";
import { initialPermisosState } from "../../core/interfaces/models/permisos.interface";

export const permisosReducer = createReducer(
  initialPermisosState,
  on(addPermisos, (_, { permisosState }) => (
    permisosState
  )),
  on(addPermisosError, (state, { debugMessage }) => ({
    ...state,
    error: true,
    debugMessage
  })),
  on(updatePermiso, (state, { permiso }) => ({
    ...state,
    permisos: state.permisos.map(u =>
      u === permiso ? permiso : u
    )
  })),
  on(deletePermiso, (state, { name }) => ({
    ...state,
    permisos: state.permisos.filter(u => u !== name)
  })),

  on(clearPermisos, () => initialPermisosState)
);
 

  /*
  initialPermisosState,
  
   on(addPermisos, (_, { permisos }) => (
    permisos 
  )),
  on(deletePermisos, () => initialPermisosState),
)
  */